<div
  class="container content mt-5 mt-lg-11 mb-11"
  *ngIf="{
    isWL: WL.isWhiteLabel | async,
    props: WL.properties | async
  } as WLd"
>
  <div class="row">
    <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <h1 class="card-title">{{ 'Login' | translate }}</h1>
            </div>
            <div class="col-auto ml-auto" *ngIf="!WL.getI('login.language-dropdown.hidden')">
              <app-language-dropdown></app-language-dropdown>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <hr class="mb-4 mb-sm-5 mt-1" />
            </div>
          </div>

          <!-- TODO: Add maintenance -->

          <form (ngSubmit)="onLogin()" [formGroup]="loginForm">
            <div class="form-group row">
              <label class="col-form-label col-sm-4" for="email">{{
                'E-mail' | translate
              }}</label>
              <div class="col-sm">
                <input
                  class="form-control"
                  name="email"
                  type="email"
                  novalidate="novalidate"
                  id="email"
                  autofocus=""
                  formControlName="email"
                  [class.is-invalid]="sent && loginForm.get('email').errors"
                />

                <div
                  class="invalid-feedback"
                  *ngIf="sent && loginForm.get('email').hasError('required')"
                >
                  {{ 'global.validators.required.error' | translate }}
                </div>

                <div
                  class="invalid-feedback"
                  *ngIf="
                    sent && loginForm.get('email').hasError('invalidEmail')
                  "
                >
                  {{ 'Please enter a valid e-mail' | translate }}
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-form-label col-sm-4" for="password">{{
                'Password' | translate
              }}</label>
              <div class="col-sm">
                <input
                  class="form-control"
                  name="password"
                  type="password"
                  novalidate="novalidate"
                  id="password"
                  formControlName="password"
                  [class.is-invalid]="
                    sent && loginForm.get('password').hasError('required')
                  "
                />

                <div
                  class="invalid-feedback"
                  *ngIf="sent && loginForm.get('password').hasError('required')"
                >
                  {{ 'global.validators.required.error' | translate }}
                </div>
              </div>
            </div>

            <div class="form-group row py-3">
              <div class="col-sm-4"></div>
              <div class="col-sm text-center text-sm-left">
                <div
                  class="custom-control custom-checkbox d-flex align-items-center text-muted"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="rememberMe"
                    name="rememberMe"
                    formControlName="rememberMe"
                  />
                  <label class="custom-control-label" for="rememberMe">
                    <span class="text-secondary">
                      {{ 'Remember me' | translate }}
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="col-sm text-center">
                <button
                  type="submit"
                  class="btn btn-lg btn-outline-primary btn-wide px-4"
                  [disabled]="loading"
                >
                  <span>{{ 'Login' | translate }}</span>
                  <i *ngIf="loading" class="fa fa-spinner fa-spin ml-2"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <p
        class="text-center pt-4"
        *ngIf="
          !WLd.isWL || WLd.props?.passwordResetURL || !WLd.props?.hideLoginPage
        "
      >
        <a
          style="cursor: pointer"
          class="btn btn-link text-secondary"
          *ngIf="WLd.isWL && WLd.props.passwordResetURL; else regularLogin"
          href="{{ WLd.props.passwordResetURL }}"
          ><u>{{ 'Forgot your password?' | translate }}</u></a
        >

        <ng-template #regularLogin>
          <a
            style="cursor: pointer"
            class="btn btn-link text-secondary"
            routerLink="/reset"
            ><u>{{ 'Forgot your password?' | translate }}</u></a
          >
        </ng-template>
      </p>

      <p
        class="text-center pb-4"
        *ngIf="!WLd.isWL || WLd.props?.signupURL || WLd.showSignup"
      >
        <a
          style="cursor: pointer"
          class="btn btn-link text-secondary"
          routerLink="/signup"
          *ngIf="WLd.isWL && WLd.props?.signupURL; else normalSignup"
          ><u>{{ 'Not signed up yet?' | translate }}</u></a
        >

        <ng-template #normalSignup>
          <a
            style="cursor: pointer"
            class="btn btn-link text-secondary"
            routerLink="/signup"
            *ngIf="!WLd.isWL"
            ><u>{{ 'Not signed up yet?' | translate }}</u></a
          >
        </ng-template>
      </p>
    </div>
  </div>
</div>
